import { getJson } from './http';
import type { WeatherResult } from './types';

/** Fetches the current forecast for a point through the site's own API. */
export function getWeather(
  latitude: number,
  longitude: number,
  signal?: AbortSignal,
): Promise<WeatherResult | null> {
  return getJson<WeatherResult | null>('/api/weather', { latitude, longitude }, signal);
}
